import { ResponseDTO } from './response-dto';

export interface SaveUserRoleContextExternalRequestResponseDTO extends ResponseDTO {
    requestKey?: string;
}

export interface SaveUserRoleContextInternalRequestResponseDTO extends ResponseDTO {}
